<dialog class="global-search-overlay" #dialogElement>
  <div class="global-search-overlay__background" (click)="onClosed.emit(true)"></div>

  <div class="global-search-overlay__content-wrapper">
    <div class="global-search-overlay__search-wrapper">
      <div class="global-search-overlay__search">
        <input type="text"
               id="global_search"
               [(ngModel)]="searchTerm"
               enterkeyhint="go"
               #inputElement
               tabindex="-1"
               class="custom-focus"
               (ngModelChange)="debouncedSearchValueUpdateTrigger()">
        <span class="global-search-overlay__search-icon global-search-overlay__search-icon--search"><brt-icon icon="search"></brt-icon></span>
        <span class="global-search-overlay__search-icon global-search-overlay__search-icon--clear" (click)="clearField()"><brt-icon icon="x-reg-circle"></brt-icon></span>
      </div>
    </div>



    <div class="global-search-overlay__results" #resultsEl>
      <div class="global-search-overlay__results-list" *ngIf="searchTerm.length; else emptyList">
        <div class="global-search-overlay__results-loading" *ngIf="isLoading; else resultsList">
          <brt-loader></brt-loader>
        </div>
        <ng-template #resultsList>
          <ng-container *ngIf="results.length > 0; else nothingFound">
            <div class="global-search-overlay__results-item" *ngFor="let result of results">
              <brt-global-search-overlay-result [data]="result"></brt-global-search-overlay-result>
            </div>
          </ng-container>
          <ng-template #nothingFound>
            <div class="global-search-overlay__results-empty">
              Nichts gefunden
            </div>
          </ng-template>

        </ng-template>

      </div>
      <ng-template #emptyList>
        <div class="global-search-overlay__results-empty">
          Gib etwas ein um zu suchen
        </div>
      </ng-template>
    </div>
  </div>



</dialog>
